module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-search",
    class: {
      'header-search--open': _vm.show
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-search__bg",
    on: {
      "click": [function($event) {
        $event.stopPropagation();
      }, function($event) {
        _vm.show = false
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-search__content"
  }, [_c('div', {
    staticClass: "header-search__form"
  }, [_c('i', {
    staticClass: "fa fa-search header-search__icon-search",
    on: {
      "click": _vm.focusSearchInput
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "focusThis",
    staticClass: "header-search__input",
    attrs: {
      "type": "text",
      "placeholder": "Поиск и фильтр, введите номер заказа, номер телефона или описание"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.show = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.show) ? _c('i', {
    staticClass: "fa fa-times header-search__icon-times",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "header-search__filter-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.query.length > 1) ? _c('div', [_c('div', {
    staticClass: "header-search__filter-wrapper-custom-scroll"
  }, [(_vm.loading.search) ? _c('div', [_c('loading', {
    attrs: {
      "size": 3,
      "message": "Ищем заказы..."
    }
  })], 1) : (_vm.result.length > 0) ? _vm._l((_vm.result), function(order) {
    return _c('div', {
      staticClass: "header-search__result"
    }, [_c('div', {
      staticClass: "row header-search__result-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showOrderDetail(order.id)
        }
      }
    }, [_c('div', {
      staticClass: "col-2 col-md-1"
    }, [_vm._v("\n                                №" + _vm._s(order.id) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-5 col-md-2 col-lg-1 col-xl-2"
    }, [_vm._v("\n                                " + _vm._s(order.date) + " в " + _vm._s(order.time) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-5 col-md-2 col-lg-1 col-xl-2"
    }, [_c('order-status', {
      attrs: {
        "order": order,
        "disabled": true
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-12 col-md-7 col-lg-4 col-xl-7 mt-1 mb-1 mb-xl-1 mt-md-0 mb-lg-0"
    }, [_vm._v("\n                                " + _vm._s(order.description) + "\n                                "), (order.status.code === 'canceled' && order.cancelCause) ? _c('div', {
      staticClass: "text-danger small"
    }, [_vm._v("Причина отмены: " + _vm._s(order.cancelCause))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-5 col-lg-2 col-xl-5"
    }, [(order.clientPhone) ? _c('span', [_vm._v("+7")]) : _vm._e(), _vm._v(_vm._s(order.clientPhone) + " " + _vm._s(order.clientName) + "\n                                "), _c('div', {
      staticClass: "small"
    }, [_vm._v("Ответственный " + _vm._s(order.user.firstname) + " " + _vm._s(order.user.lastname))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-md-7 col-lg-3 col-xl-7"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-map-marker"
    }), _vm._v(" " + _vm._s(order.techcenter.city.name) + " - " + _vm._s(order.techcenter.company.name))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "badge",
      style: ({
        backgroundColor: order.techcenter.color
      })
    }, [_vm._v(_vm._s(order.techcenter.address))]), _c('br')])])])
  }) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_vm._v("К сожалению по указанным вами параметрам не найдено ни одного заказа. Попробуйте изменить параметры поиска или воспользуйтесь "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.query = ''
      }
    }
  }, [_vm._v("подбром по фильтрам")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "header-search__filter-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary mr-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.query = ''
      }
    }
  }, [_vm._v("Показать фильтр")])])]) : [_c('div', {
    staticClass: "header-search__filter-wrapper-custom-scroll"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-4 col-lg-3"
  }, [_vm._m(0), _vm._v(" "), (_vm.filters.length > 0) ? _c('ul', {
    staticClass: "header-search__list-group"
  }, _vm._l((_vm.filters), function(filter, index) {
    return _c('li', {
      staticClass: "header-search__list-group-item d-flex justify-content-between align-items-center",
      class: {
        'header-search__list-group-item--active': _vm.activeFilterIndex === index
      },
      on: {
        "click": function($event) {
          _vm.activeFilter(filter, index)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(filter.name) + "\n                            "), _c('span', {
      staticClass: "badge badge-secondary header-search__badge-times",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.removeFilter(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])
  })) : _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('p', [_vm._v("У вас еще нет ни одного сохранненого фильтра.")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-md-down"
  }, [_vm._v("Но вы можете создать требуемые для вас фильтры в правой колонке.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-8 col-lg-9 header-search__filter-wrapper-left"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post",
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.$v.formParams.$invalid) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                            Номер заказа или период должны быть обязательно указаны\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Номера заказов")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Нажмите Enter для добавления",
      "placeholder": "Введите номера заказов",
      "label": "id",
      "track-by": "name",
      "options": _vm.formParams.ordersIds,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addOrderId,
      "select": function($event) {
        _vm.$v.formParams.ordersIds.$touch()
      },
      "remove": function($event) {
        _vm.$v.formParams.ordersIds.$touch()
      }
    },
    model: {
      value: (_vm.formParams.ordersIds),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "ordersIds", $$v)
      },
      expression: "formParams.ordersIds"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Период")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('DateRangePicker', {
    staticClass: "header-search__date-range-picker",
    attrs: {
      "range": true,
      "format": _vm.format,
      "lang": "ru",
      "width": "240",
      "first-day-of-week": 1,
      "shortcuts": false,
      "input-class": "form-control"
    },
    model: {
      value: (_vm.formParams.dates),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "dates", $$v)
      },
      expression: "formParams.dates"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.cities,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите город",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано"
    },
    model: {
      value: (_vm.formParams.cities),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "cities", $$v)
      },
      expression: "formParams.cities"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Компания")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите компанию",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.companies
    },
    model: {
      value: (_vm.formParams.companies),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "companies", $$v)
      },
      expression: "formParams.companies"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Техцентр")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.techcenters,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите техцентр",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.techcenters
    },
    model: {
      value: (_vm.formParams.techcenters),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "techcenters", $$v)
      },
      expression: "formParams.techcenters"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Ответственный")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.users,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите пользователей",
      "track-by": "id",
      "label": "fullname",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано",
      "loading": _vm.loading.users
    },
    model: {
      value: (_vm.formParams.users),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "users", $$v)
      },
      expression: "formParams.users"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Статус заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.statuses,
      "searchable": true,
      "close-on-select": true,
      "placeholder": "Выберите статус",
      "track-by": "id",
      "label": "name",
      "multiple": true,
      "select-label": "Нажмите enter чтобы добавить",
      "deselect-label": "Нажмите enter чтобы удалить",
      "selected-label": "Выбрано"
    },
    model: {
      value: (_vm.formParams.statuses),
      callback: function($$v) {
        _vm.$set(_vm.formParams, "statuses", $$v)
      },
      expression: "formParams.statuses"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Только проблемные заказы")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParams.problem),
      expression: "formParams.problem"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formParams.problem) ? _vm._i(_vm.formParams.problem, null) > -1 : (_vm.formParams.problem)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formParams.problem,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formParams.problem = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formParams.problem = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formParams, "problem", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-3 form-control-label"
  }, [_vm._v("Только отменные заказы")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParams.canceled),
      expression: "formParams.canceled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formParams.canceled) ? _vm._i(_vm.formParams.canceled, null) > -1 : (_vm.formParams.canceled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.formParams.canceled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formParams.canceled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formParams.canceled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formParams, "canceled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-search__filter-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-9 offset-lg-3"
  }, [(_vm.$v.formParams.$invalid) ? [_c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Применить")]), _vm._v(" \n                        ")] : [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_vm._v("Применить")]), _vm._v(" \n                        ")], _vm._v(" "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.saveSearchFilter",
      modifiers: {
        "saveSearchFilter": true
      }
    }],
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Сохранить фильтр")]), _vm._v(" \n                        "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clearFiltersParams($event)
      }
    }
  }, [_vm._v("Сбросить")]), _vm._v(" \n                        "), _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("Скрыть")]), _vm._v(" \n                    ")], 2)])])]], 2)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "lazy": true,
      "id": "saveSearchFilter",
      "ok-title": "Сохранить",
      "cancel-title": "Отменить",
      "title": "Сохранить фильтр"
    },
    on: {
      "shown": _vm.focusFilterItemInput,
      "ok": _vm.saveFilter
    }
  }, [_vm._v("\n        Введите название фильтра\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFilterName),
      expression: "newFilterName"
    }],
    ref: "focusModalThis",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newFilterName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFilterName = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Сохраненные фильтры")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-7b840066"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderSearchInput.vue
// module id = 1053
// module chunks = 1